import { $authHost, $host } from "./index";
import { jwtDecode } from "jwt-decode";

const getTokenUserId = () => {
    try {
        const token = localStorage.getItem("token");
        return token ? Number(jwtDecode(token)?.id) : null;
    } catch (_) {
        return null;
    }
};

const scopedPath = (basePath, userId) => {
    const tokenUserId = getTokenUserId();
    return tokenUserId && Number(userId) === tokenUserId
        ? `${basePath}/me`
        : `${basePath}/${userId}`;
};

export const requestPartnerPromoCodeApi = async ({
    desired_code,
    discount_percent,
    code_type,
    valid_until,
    request_comment,
}) => {
    const { data } = await $authHost.post("api/affiliate/promo_code_request", {
        desired_code,
        discount_percent,
        code_type,
        valid_until,
        request_comment,
    });
    return data;
};

export const getUserPartnerPromoCodeApi = async (userId) => {
    const { data } = await $authHost.get(`api/affiliate/${scopedPath("promo_code_get", userId)}`);
    return data;
};

export const getAllPartnerPromoCodeApi = async () => {
    const { data } = await $authHost.get("api/affiliate/promo_code_get_all");
    return data;
};

export const addPartnerPromoCodeApi = async (payload) => {
    const { data } = await $authHost.post("api/affiliate/promo_code_approve", payload);
    return data;
};

export const setAffiliateModelApi = async ({ model, ...rest }) => {
    const { data } = await $authHost.post("api/affiliate/set_affiliate_model", { model, ...rest });
    return data;
};

export const orderAffiliatePayOutApi = async ({
    requested_amount,
    payment_method,
    payment_details,
    order_comment,
}) => {
    const { data } = await $authHost.post("api/affiliate/affiliate_order_pay_out", {
        requested_amount,
        payment_method,
        payment_details,
        order_comment,
    });
    return data;
};

export const getUserAffiliatePayOutOrdersApi = async (userId) => {
    const { data } = await $authHost.get(`api/affiliate/${scopedPath("user_affiliate_order_pay_out_get", userId)}`);
    return data;
};

export const getAffiliateRefIdByAliasApi = async (alias) => {
    const { data } = await $host.get(`api/affiliate/affiliate_alias_get/${alias}`);
    return data;
};

export const setAffiliateAliasApi = async ({ slug }) => {
    const { data } = await $authHost.post("api/affiliate/set_affiliate_alias", { slug });
    return data;
};

export const setAffiliateNameApi = async ({ ref_name, ref_message }) => {
    const { data } = await $authHost.post("api/affiliate/set_affiliate_name", { ref_name, ref_message });
    return data;
};

export const getAffiliateAliasByUserIdApi = async (userId) => {
    const { data } = await $authHost.get(`api/affiliate/${scopedPath("affiliate_alias_get_by_user_id", userId)}`);
    return data;
};
